export enum ErrorMessageModal {
  AppointmentDateInPast = 'Пожалуйста, выберите другое время приема. Выбранное ранее время больше не доступно для записи.',
  CheckFields = 'Проверьте правильность заполнения полей формы.',
}
